import {
  GridItemResponsiveType,
} from "react-schematic";
/**
 * Grid items data
 */
type GridItemsData = GridItemResponsiveType & {
  text: string; title: string; id: string;  pathname: string; header: string;
};
export const gridItemsData: GridItemsData[] = [
  {
    id: "1",
    title: "1",  
    text: "The swift dog passed over the lazy foxes",
    header: "LIGHTBOX",
    pathname: "/seal/"
   // The gridArea useful behaviour moves a grid items position in the list 
   // based upon the view size and grid items setting sm/md/lg... etc.
   // gridArea: { md: "2/2/span 1/span 1"}
  },
  {
    id: "2",
    title: "2",
    text: "The swift dog passed over the lazy foxes",
    header: "IMG GRID",
    pathname: "/elegal/"
    // gridArea: { md: "2/2/span 1/span 1"} 
      
  },
  {
    id: "3",
    title: "3",
    text: "The swift dog passed over the lazy foxes",
    header: "PULSE BTN",
    pathname: "/contract-interact/"
  },
  {
    id: "4",
    title: "4",
    text: "The swift dog passed over the lazy foxes",
    header: "FIRE BTN",
    pathname: "/memetoday-cafe/"
  },
  {
    id: "5",
    title: "5",
    text: "The swift dog passed over the lazy foxes",
    header: "SCALE UP",
    pathname: "/raffle/"
   // gridArea: "1/1/span 1/span 1"
  },
  {
    id: "6",
    title: "6",
    text: "The swift dog passed over the lazy foxes",
    header: "EXPLODE",
    pathname: "/voting-app/"
  },
  {
    id: "7",
    title: "7",
    text: "The swift dog passed over the lazy foxes",
    header: "LATE BTN",
    pathname: "/voting-app/"
  }
  ,
  {
    id: "8",
    title: "8",
    text: "The swift dog passed over the lazy foxes",
    header: "FLAT BTN",
    pathname: "/voting-app/"
  }
];

